import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openPersonalizationSubmenu } from '../sidebarHelpers';

const turnOnRecommender = (baseUrl, navigate, recommender) => {
  return {
    id: 'turnOnRecommender',
    title: 'Turn on the recommender',
    steps: [
      {
        selector: '[data-tour="webPersonalizationLink"]',
        content: <p>Click on the "Personalization" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openPersonalizationSubmenu('[data-tour="recommenderLink"]'),
        selector: '[data-tour="recommenderLink"]',
        content: <p>Click on "Product Blocks"</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/pages?page=${recommender.pageId}&type=recommenders`, true);
        },
        selector: '[data-tour="recommenderForYou"]',
        content: (
          <>
            <p>Your product blocks are not yet visible to your customers.</p>
            <p>
              You can preview the design and what products are shown by adding <strong>/?rlv_mode=debug</strong> to the
              homepage of your website.
            </p>
            <p>This will show you all elements created in Releva.</p>
          </>
        ),
      },
      {
        selector: '[data-tour="toggleRecommenderForYou"]',
        content: <p>Turn on the product block so that it becomes visible to your customers.</p>,
        stepInteraction: true,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: recommender.running ? true : false,
  };
};

export default turnOnRecommender;
